import Vue from "vue";
import NProgress from "nprogress";
import axios from 'axios';
import Router from "vue-router";
import goTo from "vuetify/es5/services/goto";
import store from './store/store';


Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  // This is for the scroll top when click on any router link
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    return goTo(scrollTo);
  },
  // This is for the scroll top when click on any router link
  routes: [
    {
      path: "/",
      component: () => import("@/layouts/site-layout/Layout"),
      children: [
        // SITE
        {
          name: "Home",
          path: "",
          component: () => import("@/views/site/Home"),
        },
        {
          name: "Place",
          path: "place/:slug",
          component: () => import("@/views/site/Place"),
        },
        {
          name: "About",
          path: "sobre",
          component: () => import("@/views/site/About"),
        },
        {
          name: "HowItWork",
          path: "como-funciona",
          component: () => import("@/views/site/HowItWork"),
        },
        // CLIENT AREA
        {
          name: "Perfil",
          path: "perfil",
          meta: {
            requiresLogin: true
          },
          component: () => import("@/views/perfil/Perfil"),
        },
        {
          name: "ReservesUsers",
          path: "reserves",
          meta: {
            requiresLogin: true
          },
          component: () => import("@/views/reserves/ClientReserves"),
        },
      ],
    },

    {
      path: "/a",
      component: () => import("@/layouts/full-layout/Layout"),
      meta: {
        requiresLogin: true,
        requiresAdmin: true
      },
      children: [
        {
          name: "Dashboard",
          path: "",
          component: () => import("@/views/dash/Dashboard"),
        },
        {
          name: "Users",
          path: "users",
          component: () => import("@/views/users/Users"),
        },
        {
          name: "Places",
          path: "places",
          component: () => import("@/views/places/Places"),
        },
        {
          name: "Companies",
          path: "companies",
          component: () => import("@/views/companies/Companies"),
        },
        {
          name: "Commoditys",
          path: "commoditys",
          component: () => import("@/views/commodities/Commodities"),
        },
        {
          name: "Tables",
          path: "tables",
          component: () => import("@/views/seats/Seats"),
        },
        {
          name: "Gifts",
          path: "gifts",
          component: () => import("@/views/gifts/Gifts"),
        },
        {
          name: "Working",
          path: "work-day",
          component: () => import("@/views/working/WorkDay"),
        },
        {
          name: "Reserves",
          path: "reserves",
          component: () => import("@/views/reserves/Reserves"),
        },
        {
          name: "Points",
          path: "points",
          component: () => import("@/views/points/Points"),
        },
        {
          name: "Finantial",
          path: "finantial",
          component: () => import("@/views/finantial/Finantial"),
        },
      ],
    },

    {
      path: "/p",
      component: () => import("@/layouts/full-layout/Layout"),
      meta: {
        requiresLogin: true,
        requiresPlace: true
      },
      children: [
        {
          name: "DashboardPlaces",
          path: "",
          component: () => import("@/views/dash/Dashboard"),
        },
        {
          name: "Checkin",
          path: "checkin",
          component: () => import("@/views/validation/Checkin"),
        },
        {
          name: "ReservesPlaces",
          path: "reserves",
          component: () => import("@/views/reserves/Reserves"),
        },
        {
          name: "VouchersPlaces",
          path: "vouchers",
          component: () => import("@/views/vouchers/Vouchers"),
        },
        {
          name: "PlacesEst",
          path: "places",
          component: () => import("@/views/places/Places"),
        },
        {
          name: "TablesPlaces",
          path: "tables",
          component: () => import("@/views/seats/Seats"),
        },
        {
          name: "PlaceGifts",
          path: "gifts",
          component: () => import("@/views/gifts/Gifts"),
        },
        {
          name: "WorkDay",
          path: "work-day",
          component: () => import("@/views/working/WorkDay"),
        },


        // PAGAMENTOS
        {
          name: "PaymentsHistoric",
          path: "payments/historic",
          component: () => import("@/views/payments/PaymentsHistoric"),
        },
        {
          name: "PaymentsConfig",
          path: "payments/config",
          component: () => import("@/views/payments/Payments"),
        },
        // CONFIG
        {
          name: "UsersPlaces",
          path: "config/users",
          component: () => import("@/views/users/Users"),
        },

      ]
    },

    {
      path: "/signin",
      component: () => import("@/views/authentication/FullLogin"),
    },
    {
      path: "/register",
      component: () => import("@/views/authentication/FullRegister"),
    },
    {
      path: "/validation/:code",
      component: () => import("@/views/authentication/ValidationEmail"),
    },
    {
      path: "*",
      redirect: "/"
    }

  ],
});


router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start(800);
  }
  next();
});

router.beforeEach((to, from, next) => {

  if (store.state.user) {
    axios.post(`${process.env.VUE_APP_BASE_URL}/validate_token`, { token: store.state.user.token })
      .then(() => store.dispatch('SET_USER', store.state.user))
      .catch(() => store.dispatch('LOGOUT'))
  }

  to.matched.some(record => {
    let role = store.getters.GET_ROLE;
    if (record.meta.requiresLogin) {
      store.getters.GET_USER ? next() : next({ path: '/signin' })
    }
    else if (record.meta.requiresAdmin) {
      role == 'admin' ? next() : next({ path: '/' })
    }
    else if (record.meta.requiresPlace) {
      role != 'user' ? next() : next({ path: '/' })
    }
    else {
      next()
    }
  })
})

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

export default router;
